import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import "./assets/b24"

Vue.config.productionTip = false
Vue.prototype.$ymaps = window.ymaps;
Vue.prototype.$BX24 = window.BX24;

export const server = "https://b24-app-electionmap.drv6.place-start.ru/api/";

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
